module.exports = __webpack_public_path__ + "static/paulo-ricardo-166d2fac2c5eccf84b93deff268243f5.jpg";